import { render, staticRenderFns } from "./CreateTrain.vue?vue&type=template&id=48629e36&scoped=true"
import script from "./CreateTrain.vue?vue&type=script&lang=js"
export * from "./CreateTrain.vue?vue&type=script&lang=js"
import style0 from "./CreateTrain.vue?vue&type=style&index=0&id=48629e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48629e36",
  null
  
)

export default component.exports